import { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RiCloseLine } from "react-icons/ri";
import { TbDatabaseSearch } from "react-icons/tb";

function SearchPopup({ isOpen, onClose, query, setQuery, cards}) {
  const navigate = useNavigate();
  const inputRef = useRef(null); 

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const filtered = cards.filter(
    (card) =>
      card.Title.toLowerCase().includes(query.toLowerCase()) ||
      (card.Description &&
        card.Description.toLowerCase().includes(query.toLowerCase()))
  );

  const handleSelect = (id) => {
    setQuery("");  
    onClose();
    navigate(`/details/${id}`);
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <RiCloseLine 
          className="close-btn"
          onClick={() => {
            setQuery(""); 
            onClose();
          }} 
        />
        <div className="search-block">
          <TbDatabaseSearch className="search-input-icon" />
          <input
            ref={inputRef} 
            type="text"
            placeholder="Search a solution..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="search-input"
            id="search-id"
          />
        </div>

        <ul className="search-results">
          {filtered.length > 0 ? (
            filtered.map((item) => (
              <li
                key={item.id}
                className="search-item"
                onClick={() => handleSelect(item.id)}
              >
                <span>{item.Title}</span>
                {item.SubTitle && <p>{item.SubTitle}</p>}
              </li>
            ))
          ) : (
            <p className="no-results">
              {query ? "No results found" : "Type to search..."}
            </p>
          )}
        </ul>
      </div>
    </div>
  );
}

export default SearchPopup;
